import { jsxs as c, jsx as i } from "react/jsx-runtime";
import { c as x } from "./index-65016bfa.mjs";
import m, { css as s } from "styled-components";
import { Icon as p } from "./icon.js";
const r = m.div`
  &.HelperText-wrapper {
    ${({
  theme: {
    components: { helperText: e }
  }
}) => s(e.HelperTextWrapper)};
  }
`, $ = m(p)`
  &.HelperText-icon {
    ${({
  theme: {
    components: { helperText: e }
  }
}) => s(e.Icon)};
  }
`, N = m.span`
  &.HelperText {
    ${({
  theme: {
    components: { helperText: e }
  }
}) => s(e.StyledHelperText)};
  }
`;
var w = /* @__PURE__ */ ((e) => (e.SUCCESS = "success", e.ERROR = "error", e.CAUTION = "caution", e.NONE = "none", e))(w || {});
const v = ({ defaultProp: e, secondaryProp: t, disabled: T }) => {
  var h, n;
  const H = !!((h = e == null ? void 0 : e.helperText) != null && h.trim().length), l = !!((n = t == null ? void 0 : t.helperText) != null && n.trim().length) && (t == null ? void 0 : t.state) !== "none";
  return H || l ? /* @__PURE__ */ c(
    r,
    {
      onClick: (g) => {
        g.stopPropagation();
      },
      className: x(["HelperText-wrapper", { "HelperText-wrapper--secondary": l }]),
      children: [
        H && /* @__PURE__ */ i(
          N,
          {
            "data-testid": `helper-text_${e == null ? void 0 : e.id}`,
            id: e.id,
            className: x([["HelperText", "HelperText--default", { "HelperText--disabled": T }]]),
            children: e.helperText
          }
        ),
        l && /* @__PURE__ */ c(
          N,
          {
            "aria-live": "polite",
            role: "alert",
            "data-testid": `helper-text_${t == null ? void 0 : t.id}`,
            id: t == null ? void 0 : t.id,
            className: x([
              ["HelperText", "HelperText--secondary", `HelperText--${t == null ? void 0 : t.state}`, { "HelperText--disabled": T }]
            ]),
            children: [
              /* @__PURE__ */ i(
                $,
                {
                  name: t.state === "error" ? "warningFilled" : t.state === "success" ? "checkmarkFilled" : "warning",
                  className: "HelperText-icon",
                  size: "s",
                  role: "img"
                }
              ),
              /* @__PURE__ */ i("span", { children: t.helperText })
            ]
          }
        )
      ]
    }
  ) : null;
};
export {
  v as H,
  w as I
};
